import apiService from '@/services/apiService';

const actions = {
  getMeta({ commit }, payload) {
    return new Promise((resolve, reject) => {
    apiService.get(`paxelmarket/config/meta`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
    });
  },
  postMeta({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put('paxelmarket/config/meta', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },


};

export default actions;